<div class="row line-item-list">
    <div class="col-md-2 avatar">
        <i class="material-icons-outlined">credit_card</i>
    </div>
    <div class="col-md-10 body">
        <span class="row">
            <span class="col-md-12">
                {{ options.displayItem(item) }}
            </span>
        </span>
        <span class="row complement">
            <span class="col-md-12" >
                <strong [translate]="'ndf.frais.fraisCarte.carte'"></strong>{{ item.numCarte }}
            </span>
            <span class="col-md-12">
                <strong [translate]="'ndf.frais.fraisCarte.commercant'"></strong>{{ item.enseigne }} ({{ item.localite }})
            </span>
        </span>
    </div>
</div>

